import { render, staticRenderFns } from "./FormInputRadio.vue?vue&type=template&id=89131838&"
import script from "./FormInputRadio.vue?vue&type=script&lang=js&"
export * from "./FormInputRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports